module.exports = __webpack_public_path__ + "static/BannerBlockchain-ca9ba5dd1779b8ca7dd43100f17c0dc0.png";